export default "__VITE_ASSET__2a15c68b__"